<template>
  <div class='mainContainer' v-loading='pageLoading'>
    <div class='tabs'>
      <div @click='typeChange(0)' class='left' :class='{ active: type === 0 }'>水路运输类</div>
      <div @click='typeChange(1)' :class='{ active: type === 1 }'>直发/二转公路运输类</div>
      <div @click='typeChange(2)' :class='{ active: type === 2 }'>集港运输类</div>
      <div @click='typeChange(3)' :class='{ active: type === 3 }'>港口作业类</div>
      <div @click='typeChange(4)' class='right' :class='{ active: type === 4 }'>劳动服务类</div>
    </div>
    <div class='nav'>
      <el-form :model='searchForm' label-width='100px' :inline='true'>
        <el-form-item label='供应商：'>
          <el-input v-model='searchForm.supplierName' size='mini' placeholder='请输入供应商' />
        </el-form-item>
        <el-form-item label='考核时间：'>
          <el-date-picker
            v-model='examineTime'
            type='monthrange'
            align='right'
            unlink-panels
            size='mini'
            range-separator='-'
            format='yyyy-MM'
            value-format='yyyy-MM'
            start-placeholder='开始月份'
            end-placeholder='结束月份'
            :picker-options='pickerOptions'>
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'> 查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='refresh'> 刷新月度考核</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='exportData'>导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class='content'>
      <el-table
        ref='registerTable'
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        style='width: 100%'
        border
        :header-cell-style='headerCellStyle'
        :reserve-selection='true'>
        <el-table-column label='序号' type='index' align='center' min-width='50' />
        <el-table-column label='供应商' prop='supplierName' align='center' />
        <el-table-column v-if='type === 2' label='品牌' prop='brand' align='center' />
        <el-table-column label='考核时间' prop='examineTime' align='center' />
        <el-table-column label='得分' prop='score' align='center' />
        <el-table-column label='供应商等级' prop='supplierLevel' align='center' />
        <el-table-column label='数据填写人' prop='userName' align='center' />
        <el-table-column label='操作' width='205' align='center'>
          <template slot-scope='scope'>
            <el-button size='mini' class='searchBtn' type='primary'
                       @click='btnClick("details",scope.row)'>明细
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <!-- 明细 -->
    <my-details ref='detailsRef' @searchBtn='searchBtn' />
  </div>
</template>

<script>
  import {
    supplierPortWarehouseSettlementList,
  } from '@/service/warehouse';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import BatchImport from '@/components/batchImport';
  import MyDetails from './components/details';
  import { monthlyAssessmentList, monthlyAssessmentRefresh } from '@/service/supplierAssessment';
  import { deleteContract } from '@/service/contract';

  export default {
    name: 'monthlyAssessment',
    components: {
      BatchImport,
      MyDetails,
    },
    data() {
      return {
        type: 0,
        pageLoading: false,
        pickerOptions: {
          shortcuts: [
            {
              text: '本月',
              onClick(picker) {
                picker.$emit('pick', [new Date(), new Date()]);
              },
            },
            {
              text: '今年至今',
              onClick(picker) {
                const end = new Date();
                const start = new Date(new Date().getFullYear(), 0);
                picker.$emit('pick', [start, end]);
              },
            },
            {
              text: '最近六个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setMonth(start.getMonth() - 6);
                picker.$emit('pick', [start, end]);
              },
            },
          ],
        },
        searchForm: {
          supplierName: '',
          page: 1,
          rows: 10,
        },
        examineTime: ['', ''],
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        selectedData: [],
        tipOne: true,
        settlement: '',
        uploadUrl: '/settlement/supplierPortAndWarehouse/importExcel',
      };
    },
    mounted() {
      this.getDefaultDate();
      this.searchBtn();
    },
    methods: {
      getDefaultDate() {
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth()
          .toString()
          .padStart(2, '0');
        this.examineTime = [`${year}-${month}`, `${year}-${month}`];
        this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      },
      // 常规车/资源车 切换
      typeChange(val) {
        this.type = val;
        this.$nextTick(() => {
          this.tableData = [];
          this.total = 0;
          this.searchBtn();
        });
      },
      btnClick(str, row) {
        switch (str) {
          case 'details':
            this.$refs.detailsRef.dialogOpen('考核明细', row);
            break;
        }
      },
      /**
       * 生成对账单
       */
      generateStatement() {
        if (this.selectedData.length === 0) return this.$message.warning('请选择数据后生成对账单');
        this.clearSelectedData();
      },
      // 是否生成对账单格式化
      isReconciliationFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '启用';
          case 1:
            return '停用';
        }
      },
      download() {
        window.location.href = '/file/港口库房供应商结算导入模板.xlsx';
      },
      refresh() {
        this.$confirm('确认刷新月度考核么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            this.pageLoading = true;
            const {
              status,
              message,
            } = await monthlyAssessmentRefresh();
            this.pageLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.searchBtn();
          });
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
        this.getDefaultDate();
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await monthlyAssessmentList({
          ...this.searchForm,
          startExamineTime: this.examineTime[0] ? this.examineTime[0] : '',
          endExamineTime: this.examineTime[1] ? this.examineTime[1] : '',
          type: this.type,
        });
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      selectionChange(selectionRow) {
        this.selectedData = selectionRow;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      clearSelectedData() {
        this.selectedData = [];
        this.$refs.registerTable.clearSelection();
        this.searchBtn();
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        const { supplierName } = this.searchForm;
        const [startExamineTime, endExamineTime] = this.examineTime;
        // window.location.href = `${baseUrl}/platform/supplierMonthExamineManage/exportMonthExamineList?access_token=${token}&supplierName=${supplierName}&startExamineTime=${startExamineTime || ''}&endExamineTime=${endExamineTime || ''}&type=${this.type}`;
        window.exportExcelGet('/platform/supplierMonthExamineManage/exportMonthExamineList', `supplierName=${supplierName}&startExamineTime=${startExamineTime || ''}&endExamineTime=${endExamineTime || ''}&type=${this.type}`);
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 140px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
